import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/internal/operators/catchError';
import { map } from 'rxjs/internal/operators/map';
import { APIEndPoints } from 'src/app/configs/api-endpoints';
import { Store } from 'src/app/core/store/store';
import { User } from 'src/app/shared/models/user.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  url = environment.apiBaseUrl;

  constructor(private http: HttpClient, private store: Store) { }
  introVideoWatched(data){
    return this.http.put<{ data: any, result: number, msg: string }>(`${this.url}ipj/user/activation/intro-watched`, data).pipe(map(res => {
      return res.data;
    }
    ));
  }

  self() {
    return this.http.get<{ data: any, result: number, msg: string }>(`${this.url}users/self`).pipe(map((res) => {
      this.store.set('user', res.data);
      return res.data;
    }));
  }

  getProgramActivation() {
    let activeProgram=[];
    let activeResponse ={};
    return this.http.get(`${this.url}${APIEndPoints.DASHBOARD.GET_PROGRAM}`).pipe(map(res => {
      if(res){
        res['data'].forEach(element => {
          if(element.isActive){
            activeProgram.push(element);
           activeResponse ={
              data : activeProgram
            }
          }

        });
        activeResponse['msg']= res['msg'];
        activeResponse['result']= res['result'];
        return activeResponse;
      }
    }));
    // return this.http.get(`${this.url}${APIEndPoints.DASHBOARD.GET_PROGRAM}`);
  }

  getActivePrograms() {
    return this.http.get(`${this.url}${APIEndPoints.DASHBOARD.GET_ACTIVE_PROGRAM}`);
  }

  updateProgramActivation(data){
    return this.http.put<{ data: any, result: number, msg: string }>(`${this.url}ipj/user-activation/updateUserActiveProgram`, data).pipe(map(res => {
      return res.data;
    }
    ));
  }

  saveProgramFeedback(data) {
    return this.http.post<{ data: any, result: number, msg: string }>(`${this.url}ipj/feedback-and-certificate/submit-feedback`, data).pipe(map(res => {
      return res.data;
    }
    ));
  }

  endVideoWatched(data){
    return this.http.put<{ data: any, result: number, msg: string }>(`${this.url}ipj/user/activation/mark-complete`, data).pipe(map(res => {
      return res.data;
    }
    ));
  }

  getIpjCertificate(uId) {
    return this.http.get<{ data: Object, result: number, msg: string }>(`${this.url}ipj/feedback-and-certificate/fetch-certificate/${uId}`).pipe(map(res => {
      if (res && res.data) {
        return res.data
      }
    }));
  }

  masterclassThreshold(data){
    return this.http.put<{ data: any, result: number, msg: string }>(`${this.url}ipj/user-progress`, data).pipe(map(res => {
      return res.data;
    }
    ));
  }

  masterclassViewedTimeSave(data){
    return this.http.put<{ data: any, result: number, msg: string }>(`${this.url}ipj/user-progress`, data).pipe(map(res => {
      return res.data;
    }
    ));
  }  

  startCourse(data: any) {
    return this.http.post<{ data: User, result: number, msg: string }>(`${this.url}ipj/user-progress/start`, data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    )
  }

  saveTimespentOndashboard(data: any) {
    return this.http.post<{ data: User, result: number, msg: string }>(`${this.url}ipj/timeTracking/saveDashBoard`, data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    )
  }
  // To show/hide certificate
  checkProgramCompletionDatePassed(activationData) {
    let timeDiff = 0;
    if(activationData && activationData.completedOn && activationData.endDate) {
      let completedDate: any = new Date(activationData.completedOn);
      let activationEndDate: any = new Date(activationData.endDate);
      timeDiff = activationEndDate - completedDate;
    }
    if(timeDiff >= 0) {
      return false; 
    } else {
      return true;
    } 
  }
  
  startIntegration(data: any) {
    return this.http.post<{ data: User, result: number, msg: string }>(`${this.url}ipj/user-progress/start`, data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    )
  }

  getHirationHTML(currProgId, progDashboardId) {
    return this.http.get<{ data: User, result: number, msg: string }>(`${this.url}ipj/user-progress/hiration/start?programActivationId=${currProgId}&programDashboardId=${progDashboardId}&activationDashboardType=INTEGRATION`).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    )
  }

  startExercise(data: any) {
    return this.http.post<{ data: User, result: number, msg: string }>(`${this.url}ipj/user-progress/start`, data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    )
  }

  getSRTSData(data) {
    return this.http.post<{ data: any, result: number, msg: string }>(`${this.url}ipj/utility/content`, data).pipe(map(res => {
      return res.data;
    }
    ));
  }



  getActivationInfo(data: any) {
    return this.http.post<{ data: User, result: number, msg: string }>(`${this.url}ipj/user/activation-info`, data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    )
  }

  getActivationDashboard(data: any) {
    return this.http.post<{ data: User, result: number, msg: string }>(`${this.url}ipj/user/activation-dashboards`, data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    ) 
  }

  postMultiImageLinkedin(data){
    return this.http.post<{ data: User, result: number, msg: string }>(`${this.url}ipj/user/linkedin/register-upload`, data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    ) 
  }

  getLinkedinToken(data) {
    return this.http.post(`${this.url}ipj/user/linkedin/access-token`, data)
  }

  getInfosysTerm() {
    return this.http.get<{ data: User, result: number, msg: string }>(`${this.url}users/check-infosys-term`).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    ) 
  }

  acceptTermforInfosys(data){
    return this.http.post<{ data: User, result: number, msg: string }>(`${this.url}users/accept-infosys-term`, data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    ) 
  }

  linkedinAnylytics(data){
    return this.http.post<{ data: User, result: number, msg: string }>(`${this.url}ipj/user/share-certificate/analytics`, data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    ) 
  }


}
